import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import HomeChart from "../../helper/homechart.helper";
import DataTable from "../../helper/datatable.helper";
import Pie from "../../helper/piechart.helper";

import BacktestService from "../../service/backtest.service";
import Spinner from "../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import CurrentBuySell from "./Current_buy_sell";

class Current extends Component {
  _isMounted = false;
  state = {
    last: {
      a: 0,
      b: 0,
    },

    current_id: 0,
    isLoad: false,
    show: false,

    pies: [],
    displayErrorMessage: false,
    getBenchmark: [],
    monteCarloLoading: false,
  };

  tables = {
    holding: null,
  };

  componentDidMount() {
    this._isMounted = true;
    this.props.resetCurrentActiveStep(0);
  }
  async componentWillReceiveProps(nextProps) {
    this._isMounted = true;
    if (parseInt(nextProps.id) > 0 && parseInt(this.state.current_id) == 0) {
      this.setState({ current_id: nextProps.id, isLoad: true });

      await BacktestService.getBacktest(nextProps.id, "BM_60_40", "CURRENT")
        .then((res) => {
          if (this._isMounted === true) {
            this.renderAssetClassStyleCharts(res);

            this.setState({
              getBenchmark: res,
            });
          }
        })
        .catch((e) => console.log("error -1 "));

      this.setState({
        monteCarloLoading: true,
      });
      await BacktestService.getMontecarlo(nextProps.id)
        .then(this.handleMontecarloData)
        .catch((err) => {
          if (err) {
            this.setState({
              monteCarloLoading: false,
            });
          }
        });
    }
  }

  async componentDidUpdate(nextProps) {
    this._isMounted = true;
    if (
      parseInt(nextProps.id) > 0 &&
      parseInt(nextProps.id) !== parseInt(this.state.current_id)
    ) {
      this.setState({ current_id: nextProps.id, show: false, isLoad: true });

      await BacktestService.getBacktest(nextProps.id, "BM_60_40", "CURRENT")
        .then((res) => {
          if (this._isMounted === true) {
            this.renderAssetClassStyleCharts(res);

            this.setState({
              getBenchmark: res,
            });
          }
        })
        .catch((e) => console.log("error -2 "));
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  handleMontecarloData = (data) => {
    this.setState(
      {
        pies: [
          {
            name: "5th percentile Return %",
            value: data.getMontecarloMetrics[0]["5_perc_return"],
            percent: "5%",
          },
          {
            name: "25th percentile Return %",
            value: data.getMontecarloMetrics[0]["25_perc_return"],
            percent: "25%",
          },
          {
            name: "50th percentile Return %",
            value: data.getMontecarloMetrics[0]["50_perc_return"],
            percent: "50%",
          },
          {
            name: "5th percentile drawdown %",
            value: (
              +data.getMontecarloMetrics[0]["5_perc_value"] * 100
            ).toFixed(2),
            percent: "5%",
          },
          {
            name: "25th percentile drawdown %",
            value: (
              +data.getMontecarloMetrics[0]["50_perc_value"] * 100
            ).toFixed(2),
            percent: "25%",
          },
          {
            name: "50th percentile drawdown %",
            value: (
              +data.getMontecarloMetrics[0]["50_perc_value"] * 100
            ).toFixed(2),
            percent: "50%",
          },
        ],
        monteCarloLoading: false,
      },
      () => {
        setTimeout(() => {
          Pie.renderPies(".easy-pie-chart .number");
        }, 1000);
      }
    );

    this.renderMontecarlo(data);
  };

  renderMontecarlo = (data) => {
    const series = [];
    const metrics = [];
    for (let i in data.getMontecarloData) {
      series.push([
        +data.getMontecarloData[i].index,
        +data.getMontecarloData[i].value,
      ]);
    }

    metrics.push(
      [
        +data.getMontecarloMetrics[0]["5_perc_return"],
        +data.getMontecarloMetrics[0]["5_perc_value"],
      ],
      [
        +data.getMontecarloMetrics[0]["25_perc_return"],
        +data.getMontecarloMetrics[0]["25_perc_value"],
      ],
      [
        +data.getMontecarloMetrics[0]["50_perc_return"],
        +data.getMontecarloMetrics[0]["50_perc_value"],
      ]
    );

    HomeChart.renderScatterChart("#curr_goal_metrics", series);
  };

  renderAssetClassStyleCharts(current) {
    if (
      current &&
      (current.getBenchmarkVami.length ||
        current.getPortfolioVami.length ||
        current.getPortfolioData.length)
    ) {
      this.reset();

      this.setState({ isLoad: true });

      let holdings = HomeChart.renderAssetStyleStockChart(
        "#curr_asset_class_stock_place",
        "#curr_style_stock_place",
        "#curr_asset_class_pie_place",
        "#curr_style_pie_place",
        current
      );

      let cols = [
        { title: "Name", sTitle: "Name" },
        // { title: "Weight", sTitle: "Weight", width: "80px" }
        { title: "Weight", sTitle: "Weight" },
      ];

      setTimeout(() => {
        this.tables.holding = new DataTable(
          "#curr_holdings_tbl_place",
          cols,
          holdings.styles
        );
      }, 0);

      this.setState({
        ...this.state,
        last: {
          a: holdings.lastA,
          b: holdings.lastB,
        },
        isLoad: false,
      });
      // this.state.last = {
      //   a: holdings.lastA,
      //   b: holdings.lastB,
      // };

      if (holdings.styles.length) {
        if ("onShow" in this.props) this.props.onShow(true);
        this.setState({
          show: true,
        });
      }

      this.setState(this.state);
    } else {
      if ("onShow" in this.props) this.props.onShow(false);
      this.setState({
        isLoad: false,
        displayErrorMessage: true,
      });
    }
  }

  reset() {
    for (let i in this.tables) {
      if (this.tables[i]) this.tables[i].destroy();
    }
  }
  render() {
    const { getBenchmark, show, isLoad, displayErrorMessage } = this.state;
    return (
      <Fragment>
        <div>
          <Fragment>
            {getBenchmark &&
            this.props.analyzeExistingActive === true &&
            displayErrorMessage === false &&
            isLoad === false ? (
              <CurrentBuySell getBenchmark={getBenchmark} />
            ) : null}
          </Fragment>
          {show ? (
            <div>
              {/* <div className="portlet light bordered">
                <div className="portlet-title">
                  <div className="caption">
                    <i className="icon-cursor font-dark hide"></i>
                    <span className="caption-subject font-dark bold uppercase">
                      Goal Metrics
                    </span>
                  </div>
                </div>
                <div className="portlet-body">
                  <div className="row">
                    {monteCarloLoading ? (
                      <div className="col-md-12">
                        <Spinner />
                      </div>
                    ) : null}
                    <div className="col-md-6">
                      <div
                        id="curr_goal_metrics"
                        style={{ width: "100%", height: "300px" }}
                      ></div>
                    </div>
                    <div className="col-md-6">
                      <div className="portlet-body">
                        <div className="row">
                          {this.state.pies.map((pie, i) => (
                            <div key={i} className="col-md-4">
                              <div className="easy-pie-chart">
                                <div
                                  className="number"
                                  data-percent={pie.percent}
                                  data-color={pie.color}
                                >
                                  <span>{pie.value}</span>
                                </div>
                                <span className="title">{pie.name}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="portlet light bordered">
                <div className="portlet-title">
                  <div className="caption">
                    <i className="icon-cursor font-dark hide"></i>
                    <span className="caption-subject font-dark bold uppercase">
                      Asset Class Exposures (AS OF DATE {this.state.last.a})
                    </span>
                  </div>
                </div>
                <div className="portlet-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div id="curr_asset_class_pie_place"></div>
                    </div>
                    <div className="col-md-6">
                      <h3 className="text-right">Intelligent Risk</h3>
                      <p>
                        Market risk and volatility need to be managed
                        intelligently, now more than ever. At IQCIO we use a
                        disciplined, multi-faceted quantitative algorithm that
                        our team developed to determine when the Moderate Model
                        Portfolio should reduce risk.
                      </p>
                      <br />
                      <h3 className="text-right">Intelligent Income</h3>
                      <p>
                        Searching for investment income today is hard. IQCIO
                        takes an intelligent, risk averse approach to generating
                        cash flow suitable for the risk profile of the Income
                        Portfolio.
                      </p>
                      <br />
                      <h3 className="text-right">Intelligent Portfolio</h3>
                      <p>
                        Selection IQCIO’s powerful technology scours the
                        investable universe of fund opportunities and selects
                        those that allow the Portfolio to meet its goals more
                        predictably.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="portlet light bordered">
                    <div className="portlet-title">
                      <div className="caption">
                        <i className="icon-cursor font-dark hide"></i>
                        <span className="caption-subject font-dark bold uppercase">
                          Style Exposures (AS OF DATE {this.state.last.b})
                        </span>
                      </div>
                    </div>
                    <div className="portlet-body">
                      <div
                        id="curr_style_pie_place"
                        style={{ width: "100%", height: "450px" }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="portlet light bordered">
                    <div className="portlet-title">
                      <div className="caption">
                        <i className="icon-cursor font-dark hide"></i>
                        <span className="caption-subject font-dark bold uppercase">
                          Holdings (AS OF DATE {this.state.last.b})
                        </span>
                      </div>
                    </div>
                    <div className="portlet-body">
                      <table
                        className="table table-striped table-hover table-checkable order-column"
                        id="curr_holdings_tbl_place"
                      ></table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : isLoad === true ? (
            <div className="portlet light bordered">
              <div className="portlet-title">
                <Spinner />{" "}
              </div>
            </div>
          ) : // :
          // this.state.displayErrorMessage === false ? (
          //   <div className="portlet light bordered">
          //     <div className="portlet-title">
          //       <Spinner />{" "}
          //     </div>
          //   </div>
          // )
          null}
          <Fragment>
            {isLoad === false && displayErrorMessage ? (
              <Fragment>
                <div className="page-body text-center current_note">
                  <h2>
                    <i
                      className="fa fa-exclamation-circle"
                      style={{ color: "#3c548c", fontSize: " 30px" }}
                    ></i>{" "}
                    We are unable to create an optimized portfolio with the
                    Security Universe &amp; Limits you selected.
                    <br />
                    Please try again with a broader selection of securities.
                  </h2>
                </div>
              </Fragment>
            ) : null}
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        universeLite: { analyzeExistingActive },
      },
    },
  }) => ({ analyzeExistingActive }),
  (dispatch) => ({
    resetCurrentActiveStep: (value) =>
      dispatch({ type: "SET_ACTIVE_STEP_COUNT", payload: value }),
  })
)(Current);



// WEBPACK FOOTER //
// ./src/components/pages/Current.jsx